export default __webpack_public_path__ + "assets/icons/delivered.44354fc3.svg";